import React from 'react';
import { FiPlus } from 'react-icons/fi';
import styles from '../AnnouncementsV2.module.css';

const AnnouncementsHeader = ({ onCreateNew }) => {
  return (
    <div className={styles.announcementsHeader}>
      <div className={styles.headerContent}>
        <h1 className={styles.announcementsTitle}>Course Announcements</h1>
        <p className={styles.announcementsSubtitle}>
          Stay updated with important course information and updates
        </p>
      </div>
      <button className={styles.newAnnouncementButton} onClick={onCreateNew}>
        <FiPlus size={18} />
        New Announcement
      </button>
    </div>
  );
};

export default AnnouncementsHeader;
